import React from 'react';
import { Input } from '../../ui/Input';

interface NtfyForm {
  ntfyServer: string;
  ntfyTopic: string;
  ntfyToken: string;
}

interface NtfyStepProps {
  form: NtfyForm;
  onChange: (f: NtfyForm) => void;
}

export function NtfyStep({ form, onChange }: NtfyStepProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)' }}>
        Configura le notifiche push via ntfy per ricevere alert su nuovi lead, eventi e scadenze.
      </p>
      <Input label="Server ntfy" value={form.ntfyServer}
        onChange={e => onChange({ ...form, ntfyServer: e.target.value })}
        placeholder="https://ntfy.sh" />
      <Input label="Topic" value={form.ntfyTopic}
        onChange={e => onChange({ ...form, ntfyTopic: e.target.value })}
        placeholder="lenscrm-notifiche" />
      <Input label="Token (opzionale)" value={form.ntfyToken}
        onChange={e => onChange({ ...form, ntfyToken: e.target.value })}
        placeholder="tk_..." />
    </div>
  );
}
